import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import React, { PropsWithChildren } from 'react';

import { CartContextProvider } from '@/contexts/cart-context';
import { Checkout } from './checkout';
import { PaymentMethodProvider } from '@/contexts/payment-method-context';
import { useCheckoutSession } from '@/hooks/use-checkout-session';

export function CheckoutWrapper (): React.JSX.Element {
  let checkoutSession;
  try {
    [checkoutSession] = useCheckoutSession();
  } catch {
    checkoutSession = null;
  }

  const checkoutSiteKeyV3 = checkoutSession?.recaptcha?.config?.checkoutSiteKeyV3;

  const MaybeReCaptchaProvider = checkoutSiteKeyV3
    ? GoogleReCaptchaProvider
    : InactiveReCaptchaProvider;

  return (
    <CartContextProvider>
      <PaymentMethodProvider>
        <MaybeReCaptchaProvider reCaptchaKey={checkoutSiteKeyV3 || ''} useEnterprise={true}>
          <Checkout />
        </MaybeReCaptchaProvider>
      </PaymentMethodProvider>
    </CartContextProvider>
  );
}

function InactiveReCaptchaProvider ({
  children,
  reCaptchaKey: _reCaptchaKey,
  useEnterprise: _useEnterprise
}: {
  reCaptchaKey: string;
  useEnterprise: boolean;
} & PropsWithChildren): React.JSX.Element {
  return <>{children}</>;
}
